import { render, staticRenderFns } from "./ProductAttribute.vue?vue&type=template&id=4f79b087&scoped=true&"
import script from "./ProductAttribute.vue?vue&type=script&lang=js&"
export * from "./ProductAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttribute.vue?vue&type=style&index=0&id=4f79b087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f79b087",
  null
  
)

export default component.exports